import React, { useEffect, useState } from 'react';
import './RightPanel.css';
import OrderSummary from './OrderSummary/OrderSummary';
import PromoItems from './PromoItems/PromoItems';
import DiscountForm from './DiscountForm';
import { Grid, Divider, Paper, makeStyles } from '@material-ui/core';
import { money } from '../../helper/Utility'
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import EditIcon from '@material-ui/icons/Edit';
import Modal from '../AppFooter/Modal';
import EditCart from './EditCart';
import CartService from '../../services/CartService';
import { setCheckoutStep, updateLineItem, deleteLineItem, setCart } from '../../actions/actionCreators';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import HelpIcon from '@material-ui/icons/Help';
import Fade from '@material-ui/core/Fade';

var moment = require('moment');

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
  customWidth: {
    maxWidth: 500,
  },
  noMaxWidth: {
    maxWidth: 'none',
  },
}));


const RightPanel = () => {
  const classes = useStyles();
  const cart = useSelector(state => state.cartReducer);
  const checkoutStep = useSelector(state => state.navigationReducer.checkoutStep);
  const [lineItems, setLineItems] = useState(cart.line_items);
  const { t, i18n } = useTranslation();
  const [showPromoField, setShowPromoField] = useState(false);
  const mainColor = useSelector(state => state.frontConfigReducer.color);
  const matches = useMediaQuery("(max-width:599px)");
  const [openEditCart, setOpenEditCart] = useState(false);
  const [scheduleDate, setScheduleDate] = useState("");
  const [scheduleTime, setScheduleTime] = useState("");
  const dispatch = useDispatch();

  var itemTotal = 0;
  if (Object.keys(cart).length !== 0 && cart.line_items) {
    cart.line_items.map((item) => itemTotal += item?.quantity)
  }

  useEffect(() => {
    if (cart.line_items) {
      setLineItems(cart.line_items)
    }

  }, [cart])

  useEffect(() => {
    if (checkoutStep >= 3) {
      let momentDate = moment(cart.delivery.date, "YYYY-MM-DD");

      // Creating new date toLocaleDateString is subtracting a day from the cart delivery date
      // Using moment js to format dates more easily

      // const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      // const deliveryDate = new Date(cart.delivery.date).toLocaleDateString(undefined, options).slice(0, -5);
      // const deliveryArray = deliveryDate.split(" ");

      const deliveryArray = [momentDate.format("dddd"), momentDate.format("DD"), momentDate.format("MMMM")]
      // const day = deliveryArray[0].slice(0, -1);
      // deliveryArray.push(day);
      setScheduleDate(deliveryArray);
      setScheduleTime(cart.delivery.time_window_code)
    }
  }, [checkoutStep])

  const changeSchedule = () => {
    dispatch(setCheckoutStep(2));
  }

  const updateCart = async (newItem, type, itemIndex) => {
    const cartItemIndex = itemIndex;
    let newQuantity;
    if (type === 'delete') {
      newQuantity = 0;
    } else if (type === 'remove') {
      newQuantity = lineItems[cartItemIndex].quantity - 1;
    } else if (type === 'add') {
      if (cartItemIndex === -1) {
        newQuantity = 1;
      } else {
        newQuantity = lineItems[cartItemIndex].quantity + 1
      }
    }
    const updatedCart = {
      line_items: [
        {
          product_id: newItem.product_id,
          variant_id: newItem.variant_id,
          quantity: newQuantity
        }
      ]
    }
    const cartResponse = await CartService.updateLineItems(updatedCart, cart.token);
    if (cartResponse.status === 200) {
      if (type === 'delete') {
        dispatch(deleteLineItem(cartResponse.json.line_items))
      } else {
        dispatch(updateLineItem(cartResponse.json.line_items));
      }
      setLineItems(cartResponse.json.line_items);
      dispatch(setCart(cartResponse.json));
    }
  };

  return (
    <div className={"RightPanel"}>
      <h3 className="OrderSummaryText">{t("Order Summary")}</h3>
      <Paper elevation={3} style={{ borderRadius: 6 }}>
        <div className="OrderSummaryContainer">
          {matches ? <p className="ItemToltalTxt">{itemTotal} {t("items")}</p> : null}
          <OrderSummary cart={cart} cartItems={lineItems} />

          <p className="EditText" onClick={() => setOpenEditCart(true)}>{`${t("Edit cart")}`} <EditIcon style={{ fontSize: 14 }} /></p>
        </div>
        <div className="DiscountContainer">
          {matches ?
            <p className="PromoHeader" style={{ color: matches ? mainColor : 'rgb(83, 81, 81)' }} onClick={() => setShowPromoField(!showPromoField)}>{!showPromoField ? "Add" : "Hide"} Promo Code</p>
            : null
          }
          {matches && showPromoField ?
            <DiscountForm token={cart.token} email={cart.email} />
            : !matches ?
              <DiscountForm token={cart.token} email={cart.email} />
              : null
          }
        </div>
        <div className="TotalsContainer">
          {cart.discounts &&
            cart.discounts.map((discount, i) => (
              <Grid key={i} spacing={2} container className='topBorder'>
                <Grid className="paymentInfo" item xs={8}>
                  <p className="pPaymentInfo">
                    {discount.code} - {discount.amount > 0
                      ? money(discount.amount)
                      : (discount.minimum_amount > 0
                        ? `(Min $${(discount.minimum_amount / 100).toFixed(2)})`
                        : '---')
                    }
                  </p>
                </Grid>
              </Grid>
            ))
          }
          <table className="TotalsTable">
            <tbody>
              <tr>
                <td className="paymentInfo">{t("Subtotal")}</td>
                <td className="paymentValue" align="right">{money(cart.subtotal_price)}</td>
              </tr>
              {cart.total_bottle_deposit === 0 ? "" :
                <tr>
                  <td className="paymentInfo">{t("Bottle Deposit")}</td>
                  <td className="paymentValue" align="right">{money(cart.total_bottle_deposit)}</td>
                </tr>}
              <tr>
                <td className="paymentInfo">{t("Shipping")}</td>
                <td className="paymentValue" align="right">{money(cart.total_shipping_fee)}</td>
              </tr>
              {cart.total_extra_charge > 0 ?
                <tr>
                  <td className="paymentInfo">{t("Estimated adjustment (+10%)")}</td>
                  <td className="paymentValue" align="right">{money(cart.total_extra_charge)}</td>
                </tr> : null
              }
              {cart.total_discounts > 0 ?
                <tr>
                  <td className="paymentInfo">{t("Total discounts")}</td>
                  <td className="paymentValue" align="right">{`-${money(cart.total_discounts)}`}</td>
                </tr> : null
              }
              <tr>
                <td className="paymentInfo">{t("Tax")}</td>
                <td className="paymentValue" align="right">{'$' + (Number(cart.total_tax || 0) / 100).toFixed(2)}</td>
              </tr>
            </tbody>
          </table>

          <div style={{ display: "flex" }}>
            <Divider variant="fullWidth" style={{ width: '100%', marginTop: 2 }} />
          </div>

          <table className="TotalsTable">
            <tr>
              <td className="paymentInfoTotal">{t("Total")}</td>
              <td className="paymentTotal" align="right">
                {money(cart.total_price)}
                <Tooltip TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} title={
                  <div>
                    <div>
                      <p>{t(TOOLTIP_1)}<span style={{fontWeight: 'bold'}}>{t(TOOLTIP_2)}</span>{t(TOOLTIP_3)}</p>
                    </div>
                    <div style={{marginTop: '5px'}}>
                      <p>{t(TOOLTIP_4)}</p>
                    </div>
                  </div>
                }>
                  <IconButton>
                    <HelpIcon />
                  </IconButton>
                </Tooltip>
              </td>
            </tr>
          </table>
          {checkoutStep >= 3 ?
            <div>
              <div style={{ display: "flex" }}>
                <Divider variant="fullWidth" style={{ width: '100%', marginTop: 2 }} />
              </div>
              <div className="ScheduleSummaryContainer">
                <p>{cart.delivery.pickup ? t("Pickup") : t("Should arrive")}:</p>
                <p className="ScheduleText">{t(scheduleDate[0])}, {t(scheduleDate[1])} {scheduleDate[2]}</p>
                <p className="ScheduleText">{t("between")} {scheduleTime}</p>
                <a onClick={() => changeSchedule()} style={{ color: mainColor }} className="ScheduleLink">{t("Change schedule")}</a>
              </div>
            </div>
            : null}
        </div>
      </Paper>

      <h3 className="ExtraItemHeader">{t("Last minute deals")}</h3>
      <Paper elevation={3} style={{ borderRadius: 6 }}>
        <div className="ExtraItemContainer">
          <p className="ExtraItemSubText"></p>
          <PromoItems updateCart={updateCart} />
        </div>
      </Paper>
      <Modal open={openEditCart} description={editCart()} handleClose={() => setOpenEditCart(false)} title={t("Edit cart")} />
    </div >
  )

  function editCart() {
    return (
      <EditCart cart={cart} updateCart={updateCart} cartItems={lineItems} />
    )
  }
};

export default RightPanel;


const TOOLTIP_1 = "The amount corresponds to the ";
const TOOLTIP_2 = "total amount of your order plus 10%. ";
const TOOLTIP_3 = "The amount may vary according to the actual weight of the products (meat, fruit/vegetables, etc.) and according to the missing items.";
const TOOLTIP_4 = "Once your order is assembled and the transaction completed, only the actual amount of the order will be charged to your card. The amount will be adjusted within 12-48 hours from the moment you received the email of your receipt.";

const TOOLTIP_TEXT = "The amount corresponds to the total amount of your order plus 10%. The amount may vary according to the actual weight of the products (meat, fruit/vegetables, etc.) and according to the missing items.\nOnce your order is assembled and the transaction completed, only the actual amount of the order will be charged to your card. The amount will be adjusted within 12-48 hours from the moment you received the email of your receipt.";